import { Link as _RouterLink } from "react-router-dom";
import styled, { css } from "styled-components";

import { colorFromTheme } from "../../utils/color";
import { inputGlow } from "../../utils/styles";

const styles = css`
  color: ${colorFromTheme("link")};
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;

  // prevent layout shift on focus
  // and override the default focus indicator
  outline: transparent;
  border: solid 1px transparent;

  &:hover {
    color: ${colorFromTheme("link")};
    text-decoration: underline;
  }

  ${inputGlow}
`;

export const Link = styled.a`
  ${styles}
`;
/** Prefer this component. It uses react-router-compatible navigation */
export const RouterLink = styled(_RouterLink)`
  ${styles}
`;
